<template lang="pug">
  v-card
    v-card-title
      h2.card-title {{ 'base.add_animal_type' | translate }}
    v-card-content
      v-type-select(
        v-model="form.name"
        :label="$t('base.type_animal_type_name')"
        :hint="errorMessage('name')"
        :invalid="!!errorMessage('name')"
        :custom-types="[]"
        :default-types="defaultAnimalTypes"
        @select="onSelectType"
        @create-enabled="onCreateEnabled")
    
    v-card-actions
      v-btn(
        @click="onCreate"
        :loading="loading"
        :disabled="!canCreate") {{ 'base.create' | translate }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'

export default {
  name: 'CreateTypeModal',

  mixins: [formErrorsMixin],

  data: () => ({
    form: {
      name: ''
    },
    errors: {
      name: null
    },
    loading: false,
    selectedType: null,
    isDefaultType: false,
    createEnabled: false
  }),

  computed: {
    ...mapGetters('animaltypes', [
      'animalTypes',
      'defaultAnimalTypes'
    ]),

    canCreate () {
      return this.form.name && this.createEnabled
    }
  },

  mounted () {
    this.loadDefaultAnimalTypes()
  },

  methods: {
    ...mapActions('animaltypes', [
      'createAnimalType',
      'loadDefaultAnimalTypes'
    ]),

    onSelectType ({ type, isDefault }) {
      this.selectedType = type
      this.isDefaultType = isDefault
    },

    onCreateEnabled (enabled) {
      this.createEnabled = enabled
      if (!enabled) {
        this.errors.name = null
      }
    },

    async onCreate () {
      this.loading = true

      this.checkValidData()

      if (this.errors.name === null) {
        const payload = {
          farm: this.$route.params.farm_id,
          name: this.form.name
        }

        const error = await this.createAnimalType(payload)

        if (!error) {
          this.$emit('update')
          this.$emit('close')
        } else {
          this.$toasted.error(this.$t('errors.incorrect_data'))
        }
      }

      this.loading = false
    },

    checkValidData () {
      this.errors.name = null
      if (!this.form.name) {
        this.errors.name = ['3']
      } else if (this.form.name.length > 100) {
        this.errors.name = ['6', 100]
      }
    }
  }
}
</script>